import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import { Box, SxProps, Tooltip, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";

interface ICreateCampaignFormLabelProperties {
  hasValue: boolean;
  isOptional?: boolean;
  label: string;
  name: string;
  stepNumber?: number;
  sx?: SxProps<Theme>;
  tooltip?: string;
}

/**
 * Renders a label for the create campaign form fields.
 * @param name - name of the input field
 * @param hasValue - whether the input field has a value
 * @param stepNumber - the step number of the input field
 * @param label - the label of the input field
 * @param optional - whether the input field is optional
 * @param tooltip - the tooltip text for the input field
 */
export default function FormLabel({
  hasValue,
  isOptional = false,
  label,
  name,
  stepNumber,
  sx,
  tooltip,
}: ICreateCampaignFormLabelProperties) {
  const getComputedStyle = () => {
    if (hasValue) {
      return "success.main";
    }
    return "secondary.main";
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        gap: 1,
        mb: 1,
        ...sx,
      }}
    >
      {stepNumber && (
        <Box
          sx={{
            alignItems: "center",
            bgcolor: getComputedStyle(),
            borderRadius: "50%",
            color: "white",
            display: "flex",
            height: 24,
            justifyContent: "center",
            width: 24,
          }}
        >
          <strong>{stepNumber}</strong>
        </Box>
      )}
      <strong>
        <label htmlFor={name}>{label}</label>
      </strong>
      {isOptional && (
        <Typography color="text.secondary" variant="body2">
          {" "}
          (optional)
        </Typography>
      )}
      {tooltip && (
        <Tooltip title={tooltip}>
          <HelpRoundedIcon color="info" sx={{ cursor: "pointer", height: 16, width: 16 }} />
        </Tooltip>
      )}
    </Box>
  );
}
